import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AuthService } from "@shared/auth/auth.service";
import { SharedService } from "app/services/core/shared.service";
import { LabService } from "app/services/lab/lab.service";


@Component({
  selector: 'lab',
  templateUrl: './lab.component.html'
})

export class LabComponent implements OnInit {

  labName = '';
  cliaNumber = '';
  cliaSchedule = '';
  stateNumber = '';
  labType = '';
  type = 'primary';

  constructor(public labService: LabService,
    public sharedService: SharedService,
    private router: Router,
    public authService: AuthService) { };

  ngOnInit(): void {
    if (this.labService.lab == null) {
      this.router.navigate(['/home']);
    } else {
      this.labName = this.labService.lab.labName;
      this.cliaNumber = this.labService.lab.cliaNumber;
      this.cliaSchedule = this.labService.lab.cliaSchedule;
      this.stateNumber = this.labService.lab.stateNumber;
      this.labType = this.labService.lab.labType;
    }
    this.labService.currentTab = 0;
  }

  tabVisible(type: string): boolean {
    let reqRole = '';
    switch (type) {
      case 'demographics': 
      case 'associated':
      case 'specialty':
      case 'changeLog':
      {
        reqRole = 'LabTech,Admin,OfficeAdmin,ReadOnly';
        break;
      }
      case 'proficiency':
      case 'survey':{
        reqRole = 'LabTech,Admin,ReadOnly';
        break;
      }
      case 'licenseCash':{
        reqRole = 'OfficeAdmin,Admin';
        break;
      }
    }

    let roles = reqRole.split(',');
    return this.authService.userHasAtLeastOneRole(roles);
  }

}
